module.exports = __webpack_public_path__ + "img/project12_9.png.b67a7378.webp";